import module from 'catalogo/module.js'

const schema = {}

class CatalogoEmpresasService {
  constructor ($http) {
    this.$http = $http
  }

  get (config = {}) {
    return this.$http.get('/api/catalogo/empresas', {
      params: {
        empresas_internas: 'empresas_internas' in config ? (config.empresas_internas ? 1 : 0) : null,
      },
      schema,
    })
  }
}

module.service('CatalogoEmpresas', CatalogoEmpresasService)



// WEBPACK FOOTER //
// ./src/catalogo/services/Catalogo/Empresas.js